import api from 'api'

export type Dc3AttestationSignatureType =
  | 'instructor'
  | 'legal_representative'
  | 'workers_representative'

const fetchAttestationSignatureBlob = async (
  attestationId: number,
  signatureType: Dc3AttestationSignatureType
): Promise<Blob> => {
  const response = await api.get<Blob>(
    `/administration/dc3_attestations/${attestationId}/signatures/${signatureType}`,
    { responseType: 'blob' }
  )

  return response.data
}

export default fetchAttestationSignatureBlob
